import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import uniqueId from 'react-html-id';
import Button from '../../_atomic/Button/Button';
import ErrorModal from '../../_molecules/ErrorModal/ErrorModal';
import { mb100, mb10 } from '../../../utils/constants';
import { bytesToSize } from '../../../utils/helpers';
import './MediaInput.scss';

const filesLimit = {
  video: mb100,
  image: mb10,
};

class MediaInput extends Component {
  static propTypes = {
    value: PropTypes.arrayOf(PropTypes.shape({})),
    accept: PropTypes.string,
    secondary: PropTypes.bool,
    buttonLabel: PropTypes.string.isRequired,
    changeHandler: PropTypes.func.isRequired,
  }
  static defaultProps = {
    value: [],
    secondary: false,
    accept: '',
  }
  constructor() {
    super();
    uniqueId.enableUniqueIds(this);
  }
  state = {
    invalidFiles: [],
  }

  changeHandler = ({ target: { files } }) => {
    const { value, changeHandler } = this.props;

    const checkedFiles = this.fileSizeChecker(Array.from(files));
    const invalidFiles = [...this.state.invalidFiles, ...checkedFiles.invalid];
    const newValue = checkedFiles.valid.filter((item) => {
      const duplicateIndex = value.findIndex(valueItem =>
        valueItem.name === item.name &&
        valueItem.size === item.size &&
        valueItem.lastModified === item.lastModified);
      if (duplicateIndex !== -1) return false;
      return true;
    });

    changeHandler([...value, ...newValue].splice(0, 10)); // do this, coz upload only first 10 files
    this.setState(() => ({
      invalidFiles,
    }));
  }

  fileSizeChecker = (files) => {
    const invalid = [];
    const valid = [];
    files.forEach((file) => {
      if ((file.type.indexOf('image') > -1 && file.size > filesLimit.image)
        || (file.type.indexOf('video') > -1 && file.size > filesLimit.video)) { invalid.push(file); } else {
        valid.push(file);
      }
    });
    return { valid, invalid };
  }

  annulError = () => {
    this.setState(() => ({
      invalidFiles: [],
    }));
  }

  renderFileSizeRow = file => (
    <tr key={this.nextUniqueId()}>
      <td>{file.name}</td>
      <td>{bytesToSize(file.size)}</td>
      <td>{bytesToSize(file.type.indexOf('image') > -1 ? filesLimit.image : filesLimit.video)}</td>
    </tr>)

  render() {
    const mediaInputClasses = classNames({ 'media-input': true });
    const { accept, buttonLabel, secondary } = this.props;
    const { invalidFiles } = this.state;

    const isError = !!invalidFiles.length;
    return (
      <div className="media-input-wrapper">
        <ErrorModal visible={isError} footer={<Button label="Okay" clickHandler={this.annulError} secondary />}>
          <div className="error-header"> <span>The following files will not be uploaded because size is exceeded:</span> </div>
          <div className="error-sizes-wrapper">
            <table>
              <tbody>
                <tr>
                  <th>File name:</th>
                  <th>File size:</th>
                  <th>Allowed size: </th>
                </tr>
                {invalidFiles.map(invalidFile => this.renderFileSizeRow(invalidFile))}
              </tbody>
            </table>
          </div>

        </ErrorModal>
        <div className={mediaInputClasses}>
          <label htmlFor="media-input">
            <input
              value=""
              onChange={this.changeHandler}
              name="media-input"
              type="file"
              accept={accept}
              multiple
            />
            <Button label={buttonLabel} secondary={secondary} />
          </label>
        </div>
      </div>
    );
  }
}

export default MediaInput;



// WEBPACK FOOTER //
// ./src/components/_molecules/MediaInput/MediaInput.js